import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import {
  IconArrowRight,
  IconArrowUp,
  IconCalendarOutline,
  IconStarOutline,
} from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';
import Rive from '@rive-app/react-canvas';

import styles from './CheckEligibilityDE.module.css';
import { useGetStateQuery } from '../../../api/lendingApi/lendingApiQueries';
// @ts-expect-error does not recognise riv import.
import successTick from '../../../assets/animation/successTick.riv';
import { useContextStateKey } from '../../../hooks/useContextStateKey';
import { useOffersDE } from '../../../hooks/useOffers/useOffersDE';
import { useSignupRouterDE } from '../../../hooks/useSignupRouter/useSignupRouterDE';
import { TGetStateResponse } from '../../../types';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import ApplicationLoader from '../../ApplicationLoader/ApplicationLoader';
import { Button } from '../../Button/Button';

const CheckEligibilityDE = () => {
  const [isNavigating, setIsNavigating] = useState(false);

  const { navigateSignupDE } = useSignupRouterDE();

  const { isStateFetching } = useGetStateQuery<TGetStateResponse>();

  const stateKey = useContextStateKey();

  const offersInformation = useOffersDE();
  const documentRequirements = offersInformation.documentRequirements;

  useEffect(() => {
    tracking.ampli.stepLoaded({
      'Step name': 'Eligibility check',
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  if (offersInformation.isLoadingOrRedirecting) {
    return (
      <ApplicationLoader
        showMarketingPoll={offersInformation.isInExitPollTest}
      />
    );
  }

  if (!documentRequirements) {
    return null;
  }

  const navigateToTradingHistory = async () => {
    setIsNavigating(true);

    await navigateSignupDE('schritt-3', stateKey);

    setIsNavigating(false);
  };

  return (
    <section className={styles.checkEligibilityContainer}>
      <div className={styles.animationContainer}>
        <Rive
          src={successTick}
          className={styles.accountSuccessTickRive}
          data-testid="success-tick-animation"
        />
      </div>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>
          <Trans>Good news, you’re eligible!</Trans>
        </h1>
      </div>

      <section className={styles.benefitsCard}>
        <div className={styles.benefitsContainer}>
          <div className={styles.benefit}>
            <IconStarOutline className={styles.benefitIcon} />
            <p>
              <Trans>Repay early for free at any time</Trans>
            </p>
          </div>
          <div className={styles.benefit}>
            <IconCalendarOutline className={styles.benefitIcon} />
            <p>
              <Trans>Borrow from 1 day to 60 months</Trans>
            </p>
          </div>
          <div className={styles.benefit}>
            <IconArrowUp className={styles.benefitIcon} />
            <p>
              <Trans>Increases in credit possible</Trans>
            </p>
          </div>
        </div>
      </section>
      <p className={styles.terms}>
        <Trans>You are just one step away from your offer.</Trans>
      </p>

      <Button
        className={styles.nextButton}
        disabled={isStateFetching}
        loading={isNavigating}
        type="submit"
        onClick={navigateToTradingHistory}
      >
        <Trans>Next step</Trans>
        <IconArrowRight />
      </Button>
    </section>
  );
};

export default CheckEligibilityDE;
